import { ref, nextTick } from 'vue'

export function useImagePreview() {
    const visibleFlag = ref(false)
    const index = ref(0)
    const images = ref([])
    const contentRef = ref(null)

    const getImages = (dom) => {
        const imgArr = dom ? dom.getElementsByTagName('img') : []
        const urlArr = []
        for (let i = 0; i < imgArr.length; i++) {
            const img = imgArr[i]
            img.setAttribute('data-index', String(i))
            const src = img.currentSrc || img.getAttribute('src') || img.getAttribute('data-src') || img.src
            if (src) urlArr.push(src)
        }
        return urlArr
    }

    const initImages = () => {
        nextTick(() => {
            if (contentRef.value) {
                images.value = getImages(contentRef.value)
            }
        })
    }

    const handleChange = (idx) => {
        index.value = idx
    }

    const handleImageClick = (target) => {
        const dataIndex = target.getAttribute('data-index')
        let idx = Number(dataIndex)
        
        if (Number.isNaN(idx) || dataIndex === null || dataIndex === undefined) {
            const imgs = contentRef.value ? Array.from(contentRef.value.getElementsByTagName('img')) : []
            idx = imgs.indexOf(target)
            if (idx < 0) {
                const clickedSrc = target.currentSrc || target.getAttribute('src') || target.getAttribute('data-src') || target.src
                idx = images.value.indexOf(clickedSrc)
            }
            if (idx < 0) idx = 0
        }
        
        if (!images.value || images.value.length === 0) {
            images.value = getImages(contentRef.value)
        }
        
        index.value = idx
        visibleFlag.value = true
    }

    return {
        visibleFlag,
        index,
        images,
        contentRef,
        initImages,
        handleChange,
        handleImageClick
    }
}
